<template>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        append-to-body
        width="60%"
        :close-on-click-modal="false"
        :show-close="false"
        :close-on-press-escape="false"
    >
        <p
            v-if="DataReady"
            class="alert-text"
        >
            {{ titleText }}
        </p>
        <div>
            <xx-table-pro
                v-if="dialogVisible"
                ref="courseTable"
                name="courseTable"
                :columns="TableColumnsConfig"
                :build-params="buildParams"
                :response-processor="responseProcessor"
                :ajax="ajax"
                :pagination="{show: true, pageSize:20}"
                border
            >
                <template
                    slot="courseId"
                    slot-scope="{row}"
                >
                    <el-button
                        type="text"
                        :disabled="isButtonBan"
                        :loading="isButtonBan"
                        @click="goToCoursePage(row)"
                    >
                        跳转到课程
                    </el-button>
                </template>
                <template
                    slot="learnStatus"
                    slot-scope="{row}"
                >
                    {{ learnStatusMap[row.learnStatus] }}
                </template>
            </xx-table-pro>
        </div>
        <div
            v-if="!isForceActice"
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="clickHandler"
            >
                {{ scene === 'PASSIVE' ? '关闭': '暂时忽略' }}
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
/**
 * 访问任何一个供应商页面时，看是否存在没有完成的强制课程，如果有就弹窗并展示该页面下的强制课程列表，如果学习剩余期限>0 则展示“忽略”按钮，否则不展示“忽略”按钮。
 */
import { COURSE_CONTROL_TYPE } from 'common/constants';

const BaseTableColumnsConfig = [
    {
        label: '课程名称',
        prop: 'courseName',
        showOverflowTooltip: true,
        minWidth: 188,
    },
    {
        label: '学习计划完成度',
        prop: 'speed',
        template: {
            tpl: {
                props: ['value'],
                render() {
                    return (
                        <span>{this.value}%</span>
                    );
                },
            },
        },
    },
    {
        prop: 'courseId',
        label: '课程链接',
    },
];
const PreCourseFields = [{
    label: '学习期限',
    prop: 'forceValidPeriod',
    template: {
        tpl: {
            props: ['value'],
            render() {
                return (
                    <span>{this.value}天</span>
                );
            },
        },
    },
}];
const CourseConfigMap = {
    [COURSE_CONTROL_TYPE.WEAK]: {
        title: '推送课程',
    },
    [COURSE_CONTROL_TYPE.FORCE]: {
        title: '功能前置课程',
    },
};
export default {
    name: 'VssCourseDialog',
    props: {
        courseType: { // 0 - 推送课程，1 - 前置课程（强制课）
            type: Number,
            require: true,
            default: COURSE_CONTROL_TYPE.FORCE,
        },
        scene: {
            type: String,
            require: false,
            default: 'PASSIVE', // PASSIVE - 用户点进来看, ACTIVE - 主动弹出
        },
        menuCode: {
            type: [Number, String],
            require: false,
            default: undefined,
        },
    },
    data() {
        return {
            CourseConfigMap,
            dialogVisible: false,
            isForceActice: false,
            isButtonBan: false,
            DataReady: false,
        };
    },
    computed: {
        ajax() {
            return {
                url: '/api/vss/shepherd/announcement/queryVss',
                type: 'hPost',
                params: { type: 2, force: this.courseType, menuCode: this.menuCode },
            };
        },
        TableColumnsConfig() {
            return this.courseType === COURSE_CONTROL_TYPE.FORCE ? BaseTableColumnsConfig.concat(PreCourseFields) : BaseTableColumnsConfig;
        },
        dialogTitle() {
            return this.CourseConfigMap[this.courseType].title || '';
        },
        titleText() {
            if (this.isForceActice) return '尊敬的供应商合作伙伴，您已多次忽略功能前置课程学习，请先完成新商地图课程的学习，否则无法使用相关界面功能。';
            if (this.courseType === COURSE_CONTROL_TYPE.FORCE) { return '尊敬的供应商合作伙伴，为了您可以更好地使用系统功能，请尽快学习下面指定课程，若在学习期限截止前，仍未完成课程学习，则无法正常使用相关功能'; }
            if (this.courseType === COURSE_CONTROL_TYPE.WEAK) { return '尊敬的供应商合作伙伴，为了您可以更好地使用系统功能，请尽快学习下面指定课程。'; }
            return '';
        },
    },
    methods: {
        async goToCoursePage(row) {
            this.isButtonBan = true;
            try {
                const _supplierInfo = localStorage.getItem('supplierInfo');
                let _customerId = '';
                if (_supplierInfo) {
                    _customerId = JSON.parse(_supplierInfo).customerId || '';
                }
                if (!_customerId) {
                    this.$message.error('未找到供应商ID');
                    return;
                }
                const token = await this.$hGet('/api/vss/shepherd/account/getToken');
                if (token) {
                    window.open(`${row.url}?bAccountChannel=maicai&poiId=${_customerId}&BSID=${token}`);
                } else {
                    this.$message.error('获取用户token失败，请稍后重试');
                }
            } catch (e) {
                this.$message.error(e.message || '获取用户token失败，请稍后重试');
            } finally {
                this.isButtonBan = false;
            }
        },
        buildParams(params, tableParams) {
            return {
                ...params,
                paging: {
                    offset: tableParams.paging.offset,
                    limit: tableParams.paging.limit,
                },
            };
        },
        responseProcessor(res) {
            if (this.courseType === COURSE_CONTROL_TYPE.FORCE && res.announcementInfoList.find((item) => item.retainForceValidPeriod <= 0)) {
                // 发现有一个前置课程的学习期限为0，立即启动强制状态！
                this.isForceActice = true;
            } else {
                this.isForceActice = false;
            }

            this.DataReady = true;

            return {
                data: res.announcementInfoList,
                total: res.total,
            };
        },
        init() {
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
        },
        clickHandler() {
            this.close();
        },
    },
};
</script>
<style scoped lang="scss">
.refersh-btn {
  border-radius: 5px;
  margin: 0 0 10px 85%;
}
.alert-text {
  padding: 8px 30px;
  background-color: #fef0f0;
  color: #f56c6c;
  text-align: left;
}
</style>
